import { NeutralTypeEnum } from 'shared/components/button/components/neutral-button/enum/neutral-type-enum'

export const getHoverColor = (type: NeutralTypeEnum): string => {
  switch (type) {
    case NeutralTypeEnum.danger: {
      return 'hover:text-danger'
    }
    case NeutralTypeEnum.blue: {
      return 'hover:text-brand-primary'
    }
    default: {
      return 'text-brand-primary'
    }
  }
}

export const getHoverBorderColor = (type: NeutralTypeEnum): string => {
  switch (type) {
    case NeutralTypeEnum.danger: {
      return 'hover:border-danger'
    }
    case NeutralTypeEnum.blue: {
      return 'hover:border-brand-primary'
    }
    default: {
      return 'border-brand-primary'
    }
  }
}
